// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Lqa-","content":"Consent_content__2ZNiR","footer":"Consent_footer__1YGRg"};